import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.002 21.5a9.255 9.255 0 0 1-3.705-.748 9.596 9.596 0 0 1-3.018-2.03 9.591 9.591 0 0 1-2.03-3.016 9.245 9.245 0 0 1-.749-3.704c0-1.314.25-2.55.748-3.705a9.596 9.596 0 0 1 2.03-3.017 9.593 9.593 0 0 1 3.017-2.032A9.248 9.248 0 0 1 12 2.5c1.053 0 2.05.158 2.99.475A9.66 9.66 0 0 1 17.577 4.3l-1.085 1.11a8.184 8.184 0 0 0-2.1-1.039A7.622 7.622 0 0 0 12 4c-2.217 0-4.104.78-5.663 2.338C4.78 7.896 4 9.783 4 12s.78 4.104 2.337 5.663C7.896 19.22 9.783 20 12 20s4.104-.78 5.663-2.337C19.22 16.104 20 14.217 20 12c0-.351-.023-.699-.07-1.042a7.129 7.129 0 0 0-.207-1.002l1.212-1.221c.183.514.323 1.043.42 1.586.097.544.145 1.103.145 1.679 0 1.314-.25 2.55-.748 3.705a9.595 9.595 0 0 1-2.03 3.016 9.593 9.593 0 0 1-3.016 2.03 9.248 9.248 0 0 1-3.704.749m-1.421-5.246L6.677 12.35l1.054-1.054 2.85 2.85 9.865-9.88L21.5 5.318z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }